import moment from "moment"
import "moment-timezone"
import "moment/locale/it"
import { padStart } from "lodash";
declare var Math: Math;

export interface DaysOfWeek {
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
}

export interface DateDto {
    day: number;
    month: number;
    year: number;
}

export class DatesHelper {
    static MinDateDto = { day: 1, month: 1, year: 1901 };
    static MaxDateDto = { day: 31, month: 12, year: 2099 };

    static MinDate = new Date(1970, 1, 1, 0, 0, 0);
    static MaxDate = new Date(2099, 12, 31, 23, 59, 59);

    static ToInputDateFormat(date: Date): string {
        return `${date.getFullYear()}-${padStart((date.getMonth() + 1).toString(), 2, "0")}-${padStart(date.getDate().toString(), 2, "0")}`
    }

    static ToDate(date: Date) {
        return moment(date)
            // .tz(timezone ?? "Europe/Rome")
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .toDate();
    }

    static Today() {
        return DatesHelper.ToDate(new Date());
    }

    static ToDateDto(date: Date): DateDto {
        return {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
        };
    }
    static ToDateTimeDto(date: Date) {
        return {
            y: date.getFullYear(),
            m: date.getMonth() + 1,
            d: date.getDate(),
            hrs: date.getHours(),
            min: date.getMinutes(),
            sec: date.getSeconds(),
            mil: date.getMilliseconds(),
            off: date.getTimezoneOffset(),
        };
    }
    static FromDateTimeDto(dto: {
        y: number;
        m: number;
        d: number;
        hrs: number;
        min: number;
        sec: number;
        mil: number;
    }) {
        return new Date(dto.y, dto.m - 1, dto.d, dto.hrs, dto.min, dto.sec, dto.mil);
    }

    static EndOfDay(date: Date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
    }
    static FirstOfMonthByDate(date: Date) {
        return DatesHelper.FirstOfMonth(date.getFullYear(), date.getMonth());
    }
    static FirstOfMonth(year: number, month: number) {
        return new Date(year, month, 1);
    }
    static EndOfMonthByDate(date: Date) {
        return DatesHelper.EndOfMonth(date.getFullYear(), date.getMonth());
    }
    static EndOfMonth(year: number, month: number) {
        return new Date(year, month + 1, 0, 23, 59, 59, 999);
    }

    static GetTimeOnly(date: Date): Date {
        var d = new Date(0);
        d.setHours(date.getHours());
        d.setMinutes(date.getMinutes());
        d.setSeconds(date.getSeconds());
        d.setMilliseconds(date.getMilliseconds());
        return d;
    }
    static AddMonths(date: Date, months: number) {
        var newDate = new Date(date);
        newDate.setMonth(newDate.getMonth() + months);
        return newDate;
    }
    static AddMilliseconds(date: Date, milliseconds: number) {
        var newDate = new Date(date);
        newDate.setMilliseconds(newDate.getMilliseconds() + milliseconds);
        return newDate;
    }
    static Add(date: Date, what: {
        years?: number,
        months?: number,
        days?: number,
        milliseconds?: number,
    }) {
        var newDate = new Date(date);
        if (what.milliseconds != null)
            newDate.setMilliseconds(newDate.getMilliseconds() + what.milliseconds);
        if (what.years != null)
            newDate.setFullYear(newDate.getFullYear() + what.years);
        if (what.months != null)
            newDate.setMonth(newDate.getMonth() + what.months);
        if (what.days != null)
            newDate.setDate(newDate.getDate() + what.days);
        return newDate;
    }
    static AddDays(date: Date, days: number) {
        var newDate = new Date(date.valueOf());
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    }

    static SubtractDays(date: Date, days: number) {
        var newDate = new Date(date.valueOf());
        newDate.setDate(newDate.getDate() - days);
        return newDate;
    }

    static AddHours(date: Date, hours: number, minutes?: number) {
        var newDate = new Date(date.valueOf());
        newDate.setHours(newDate.getHours() + hours, newDate.getMinutes() + (minutes != null ? minutes : 0));
        return newDate;
    }

    static AddMinutes(date: Date, minutes: number) {
        return moment(date).add(minutes, 'm').toDate();
    }

    static AddTicks(date: Date, ticks: number) {
        return new Date(date.valueOf() + ticks);
    }
    static GetDate(date: { year?: number, month?: number, day?: number, hours?: number, minutes?: number, seconds?: number }): Date {
        var d = new Date(0);
        if (date.year)
            d.setFullYear(date.year);
        if (date.month)
            d.setMonth(date.month || 0);
        d.setDate(date.day || 1);
        d.setHours(date.hours || 0);
        d.setMinutes(date.minutes || 0);
        d.setSeconds(date.seconds || 0);
        return d;
    }

    static compactDateString(date: Date) {
        return `${padStart((date.getFullYear() % 100).toString(), 2, "0")}${padStart((date.getMonth() + 1).toString(), 2, "0")}${padStart(date.getDate().toString(), 2, "0")}`;
    }

    static fromCompactDateString(compactDate: string) {
        return new Date(2000 + +compactDate.substr(0, 2), +compactDate.substr(2, 2) - 1, +compactDate.substr(4, 2));
    }

    static compactUTCDateWithMinutesString(date: Date) {
        return `${padStart((date.getUTCFullYear() % 100).toString(), 2, "0")}${padStart((date.getUTCMonth() + 1).toString(), 2, "0")}${padStart(date.getUTCDate().toString(), 2, "0")}${padStart(date.getUTCHours().toString(), 2, "0")}${padStart(date.getUTCMinutes().toString(), 2, "0")}`;
    }

    static fromCompactUTCDateWithMinutesString(compactDate: string) {
        return new Date(Date.UTC(2000 + +compactDate.substr(0, 2), +compactDate.substr(2, 2) - 1, +compactDate.substr(4, 2), +compactDate.substr(6, 2), +compactDate.substr(8, 2)));
    }


    static dateOnlyString(date: Date) {
        return `${padStart(date.getFullYear().toString(), 4, "0")}${padStart((date.getMonth() + 1).toString(), 2, "0")}${padStart(date.getDate().toString(), 2, "0")}`;
    }

    static fromDateOnlyString(compactDate: string) {
        return new Date(+compactDate.substr(0, 4), +compactDate.substr(4, 2) - 1, +compactDate.substr(6, 2));
    }

    static getDateString(inputDate: undefined): undefined;
    static getDateString(inputDate: null): undefined;
    static getDateString(inputDate: Date): string;
    static getDateString(inputDate: Date | undefined | null) {
        if (!inputDate)
            return undefined;
        return inputDate.getFullYear() + "-" + (inputDate.getMonth() + 1) + "-" + inputDate.getDate();
    }

    static getTimeWithDaysOffset(hours: number, minutes: number, daysOffset: number) {
        var value = `${padStart((hours % 24).toString(), 2, "0")}:${padStart(minutes.toString(), 2, "0")}`;
        if (daysOffset > 0)
            value += "+" + daysOffset;
        else if (daysOffset < 0) {
            value += "-" + (-daysOffset).toString();
        }
        return value;
    }

    static formatHoursAndMinutes(hours: number, minutes: number) {
        return `${padStart((hours % 24).toString(), 2, "0")}:${padStart(minutes.toString(), 2, "0")}`;
    }

    static getDaysOffset(startDate: Date, date: Date) {
        var d1: Date;
        var d2: Date;
        if (startDate < date) {
            d1 = DatesHelper.ToDate(startDate);
            d2 = DatesHelper.ToDate(date);
        }
        else {
            d1 = DatesHelper.ToDate(date);
            d2 = DatesHelper.ToDate(startDate);
        }
        let days = 0;
        while (d1.getFullYear() !== d2.getFullYear() || d1.getMonth() !== d2.getMonth() || d1.getDate() !== d2.getDate()) {
            days++;
            d1.setDate(d1.getDate() + 1);
        }

        if (startDate < date) {
            return days;
        }
        else {
            return -days;
        }
    }
    static getItalianHoursAndMinutes(date: Date, timezone?: string) {
        let d = moment(date).tz(timezone ?? "Europe/Rome");
        return { hours: d.hours(), minutes: d.minutes() }
    }
    static getTimeWithDaysOffset1(startDate: Date, date: Date, timezone?: string) {
        let daysOffset = DatesHelper.getDaysOffset(startDate, date);
        var d = moment(date).tz(timezone ?? "Europe/Rome");
        return DatesHelper.getTimeWithDaysOffset(d.hours(), d.minutes(), daysOffset)
    }
    static getTimeString(date: Date, timezone?: string) {
        return moment(date).tz(timezone ?? "Europe/Rome").format("HH:mm");
    }
    static getTimeStringWithSeconds(date: Date, timezone?: string) {
        return moment(date).tz(timezone ?? "Europe/Rome").format("HH:mm:ss");
    }
    static getReadableDateTimeString(inputDate: Date, timezone?: string): string {
        return moment(inputDate).tz(timezone ?? "Europe/Rome").format("DD/MM/YYYY HH:mm");
    }
    static getFormattedDateTime(inputDate: Date, format: string, timezone?: string): string {
        return moment(inputDate).tz(timezone ?? "Europe/Rome").format(format);
    }
    static getReadableTimeString(inputDate: Date, timezone?: string): string {
        return moment(inputDate).tz(timezone ?? "Europe/Rome").format("HH:mm");
    }
    static getReadableDateTimeStringWithSeconds(inputDate: Date): string {
        return DatesHelper.getReadableDateTimeString(inputDate) + ":" + padStart(inputDate.getSeconds().toString(), 2, "0");
    }
    static getReadableDateString(inputDate: Date, format?: string, timezone?: string): string {
        return moment(inputDate).tz(timezone ?? "Europe/Rome").format(format || "DD/MM/YYYY");
    }
    static getReadableCompactDateString(date: Date) {
        return `${padStart(date.getDate().toString(), 2, "0")}/${padStart((date.getMonth() + 1).toString(), 2, "0")}/${padStart((date.getFullYear() % 100).toString(), 2, "0")}`;
    }
    static getReadableDateDtoString(inputDate: DateDto): string {
        return moment(DatesHelper.fromDateDto(inputDate)!).format("DD/MM/YYYY");
    }

    static fromDateDto(inputDate: undefined | null): null | undefined;
    static fromDateDto(inputDate: DateDto): Date;
    static fromDateDto(inputDate: DateDto | undefined | null) {
        if (!inputDate)
            return inputDate;
        return new Date(inputDate.year, inputDate.month - 1, inputDate.day);
    }

    static getReadableDateDayMonthStringNoTimeZone(inputDate: Date): string {
        return moment(inputDate)
            //.tz(timezone ?? "Europe/Rome")
            .format("DD/MM");
    }

    static getReadableDateDayMonthString(inputDate: Date, timezone?: string): string {
        return moment(inputDate)
            .tz(timezone ?? "Europe/Rome")
            .format("DD/MM");
    }

    static differenceInMinutes(date1: Date, date2: Date): number {
        var d1: Date;
        var d2: Date;
        if (date1 < date2) { d1 = date2; d2 = date1; }
        else { d1 = date1; d2 = date2; }

        return (d1.valueOf() - d2.valueOf()) / 60000;
    }

    static differenceInHoursAndMinutes(date1: Date, date2: Date): { hours: number, minutes: number } {
        var d1: Date;
        var d2: Date;
        if (date1 < date2) { d1 = date2; d2 = date1; }
        else { d1 = date1; d2 = date2; }

        var totalminutes = (d1.valueOf() - d2.valueOf()) / 60000;
        var hours = Math.floor(totalminutes / 60);
        var minutes = Math.ceil(totalminutes % 60);
        if (date1 < date2) {
            hours = -hours;
            minutes = -minutes;
        }
        return { hours: hours, minutes: minutes };
    }

    static daysInMonth(year: number | null, month: number | null) {
        return (year != null && month != null)
            ? moment(new Date(year, month, 1)).daysInMonth()
            : null;
    }

    static getMonthName(date: Date, hl: string, timezone?: string, fullName?: boolean): string {
        return moment(date).tz(timezone ?? "Europe/Rome").locale(hl).format(fullName ? "MMMM" : "MMM");
    }

    static getDayOfMonth(date: Date, hl: string, timezone?: string): string {
        return moment(date).tz(timezone ?? "Europe/Rome").locale(hl).format("DD");
    }

    static getDayOfWeekName(date: Date, hl: string, timezone?: string): string {
        return moment(date).tz(timezone ?? "Europe/Rome").locale(hl).format("dddd");
    }

    static distanceInWords(date1: Date, date2: Date) {
        const d = DatesHelper.differenceInHoursAndMinutes(date1, date2);
        let res = "";
        if (d.hours > 0)
            res += d.hours + " ore";
        if (d.minutes > 0) {
            if (res.length > 0)
                res += " ";
            res += d.minutes + " minuti";
        }
        return res;
    }

    static differenceInDays(date1: Date, date2: Date): { days: number } {

        var d1: Date;
        var d2: Date;

        if (date1 < date2) {
            d1 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 23, 59, 59);
            d2 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate(), 0, 0, 0);
        }
        else {
            d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate(), 23, 59, 59);
            d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate(), 0, 0, 0);
        }

        var days = Math.round((d1.valueOf() - d2.valueOf()) / (1000 * 60 * 60 * 24));

        return { days: days };
    }

    static getMinDate(dates: Date[]) {
        if (dates && dates.length > 0) {
            var minValue = Number.MAX_VALUE;
            dates.forEach(x => {
                if (x.valueOf() < minValue)
                    minValue = x.valueOf();
            });
            return new Date(minValue);
        }
        else {
            return undefined;
        }
    }

    static getMaxDate(dates: Date[]) {
        if (dates && dates.length > 0) {
            var maxValue = 0;
            dates.forEach(x => {
                if (x.valueOf() > maxValue)
                    maxValue = x.valueOf();
            });

            return new Date(maxValue);
        }
        else { return undefined; }
    }

    static graterThan(dateToCompare: Date, date: Date, useTime: boolean = true): boolean {
        var d1 = useTime ? dateToCompare : this.ToDate(dateToCompare);
        var d2 = useTime ? date : this.ToDate(date);
        return d1.valueOf() > d2.valueOf();
    }

    static graterOrEqualThan(dateToCompare: Date, date: Date, useTime: boolean = true): boolean {
        var d1 = useTime ? dateToCompare : this.ToDate(dateToCompare);
        var d2 = useTime ? date : this.ToDate(date);
        return d1.valueOf() >= d2.valueOf();
    }

    static getNearDates(date: Date, daysBack: number, totDays: number): Date[] {
        var datesResult: Date[] = [];
        datesResult.push(DatesHelper.ToDate(date));
        for (var i = 0; i < daysBack; i++) {
            let d = DatesHelper.AddDays(datesResult[0], -1);
            //if (DatesHelper.graterOrEqualThan(d, today, false))
            datesResult.splice(0, 0, d);
        }
        for (var j = (datesResult.length - 1); datesResult.length <= totDays; j++) {
            let d = datesResult[j];
            datesResult.push(DatesHelper.AddDays(d, 1));
        }

        return datesResult;
    }
    static enumerateFullDates(from: Date, to: Date): Date[] {
        var datesResult: Date[] = [];
        let current = DatesHelper.ToDate(from);
        let maxDate = DatesHelper.ToDate(to);
        for (var i = 0; current.valueOf() <= maxDate.valueOf(); i++) {
            datesResult.push(current);
            current = new Date(current.valueOf());
            current.setDate(current.getDate() + 1);
        }
        return datesResult;
    }

    static getAge(birthDate: Date) {
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    static NowWithMinutePrecision() {
        const d = new Date();

        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), 0, 0);
    }



    static IsDayOfWeek(date: Date, daysOfWeek: DaysOfWeek) {
        const dayIndex = date.getDay();
        return dayIndex === 1 && daysOfWeek.monday
            || dayIndex === 2 && daysOfWeek.tuesday
            || dayIndex === 3 && daysOfWeek.wednesday
            || dayIndex === 4 && daysOfWeek.thursday
            || dayIndex === 5 && daysOfWeek.friday
            || dayIndex === 6 && daysOfWeek.saturday
            || dayIndex === 7 && daysOfWeek.sunday;
    }
}

export default DatesHelper;